import { useState, useEffect, useRef } from "react";
import { CloseRounded } from "@mui/icons-material";
import Thumbnail from "../../components/thumbnail";
import SpinLoader from "../../components/spin-loader";

const PlayerWidget = ({ data }) => {
    const [item, setItem] = useState();
    const playerRef = useRef();
    const [playerPos, setPlayerPos] = useState();
    const [floating, setFloating] = useState();
    
    // const onScreen = useOnScreen(playerRef, '0px',
    // {
    //     position:'absolute',
    //     top:0,
    //     left:0,
    //     width:'100%',
    //     height:'100%'
    // },{
    //     position:'fixed',
    //     right : data.settings.floatPosition==='br' || data.settings.floatPosition==='tr' ? '10px' : 'initial',
    //     left : data.settings.floatPosition==='bl' || data.settings.floatPosition==='tl' ? '10px' : 'initial',
    //     top : data.settings.floatPosition==='tr' || data.settings.floatPosition==='tl' ? '10px' : 'initial',
    //     bottom : data.settings.floatPosition==='br' || data.settings.floatPosition==='bl' ? '10px' : 'initial',
    //     width : data.settings.floatWidth,
    //     height:`calc(${data.settings.floatWidth}/1.778)`
    // });

    useEffect(()=>{
        if(data.content.length){
            setItem(data.content[0]);
        }
    },[]);

    const closeFloat=()=>{
        setFloating(false);
        setPlayerPos({
            position:'absolute',
            top:0,
            left:0,
            width:'100%',
            height:'100%'
        });
    }

    useEffect(()=>{
        let firstIteration = true;
        const observer = new IntersectionObserver(([entry]) => {
              // Update our state when observer callback fires
              if(entry.isIntersecting){
                firstIteration = false;
                setFloating(false);
                setPlayerPos({
                    position:'absolute',
                    top:0,
                    left:0,
                    width:'100%',
                    height:'100%'
                });
              }else if(!firstIteration){
                setFloating(true);
                setPlayerPos({
                    position:'fixed',
                    right : data.settings.floatPosition==='br' || data.settings.floatPosition==='tr' ? `${data.settings.floatPadding || `20px`}` : 'initial',
                    left : data.settings.floatPosition==='bl' || data.settings.floatPosition==='tl' ? `${data.settings.floatPadding || `20px`}` : 'initial',
                    top : data.settings.floatPosition==='tr' || data.settings.floatPosition==='tl' ? `${data.settings.floatPadding || `20px`}` : 'initial',
                    bottom : data.settings.floatPosition==='br' || data.settings.floatPosition==='bl' ? `${data.settings.floatPadding || `20px`}` : 'initial',
                    width : data.settings.floatWidth,
                    //height:`calc(${data.settings.floatWidth}/1.778)`
                });
              }
        
        });

        if (data.settings.float && playerRef.current) {
            observer.observe(playerRef.current);
        }

        return () => {
            observer.unobserve(playerRef.current);
        };
    },[playerRef]);

    return(
        <>
            <div ref={playerRef} className={`relative w-full bg-black overflow-hidden ${data.settings.float ? 'pt-16/9': ''}`} >
                {item && <>
                    <Thumbnail className="absolute top-0 left-0 opacity-50 blur-lg" item={item} settings={data.settings}/>
                    <div className="flex flex-col" style={playerPos}>
                        {floating && <div className="flex flex-row-reverse">
                                <CloseRounded
                                    fontSize="medium"
                                    className="vf-player-close text-black/70 hover:text-black cursor-pointer"
                                    onClick={closeFloat}
                                />
                        </div>}
                        <div className="overflow-hidden bg-black relative pt-16/9">
                            <Thumbnail className="absolute top-0 left-0 opacity-50 blur-lg" item={item} settings={data.settings}/>
                            <SpinLoader className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[50px] h-[50px]"/>
                            <iframe
                                //src={`http://localhost:3002/widget/${data.id}/player/${item.id}`}
                                src={`https://www.videoflow.io/widget/${data.id}/player/${item.id}`}
                                title={item.name}
                                className="absolute top-0 left-0 w-full h-full"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </>}
            </div>
        </>
        
    )
}

export default PlayerWidget;